import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ReleaseNoteTypes } from "src/app/models/release-note-types";

@Component({
  selector: "release-note-types-handler",
  templateUrl: "./release-note-types-handler.component.html",
})
export class ReleaseNoteTypesHandlerComponent implements OnInit {

  @Input() public readyOnly: boolean = true;
  @Input() public size: string = null;
  @Input() public selectedTypes: any[] = [];
  @Output() public setSelectedTypes = new EventEmitter();

  public releaseNotesTypes: any = [];

  public ngOnInit() {
    console.log("--- releaseNotesTypes", this.releaseNotesTypes, this.selectedTypes);
    Object.keys(ReleaseNoteTypes).forEach((t) => {
      this.releaseNotesTypes.push({
        type: t,
        status: false,
      });
    });
    if (this.selectedTypes.length && this.readyOnly) {
      this.releaseNotesTypes = [];
      this.selectedTypes.forEach((s) => {
        this.releaseNotesTypes.push({
          type: s,
          status: true,
        });
      });
    }
  }

  public toggleStatus(t) {
    console.log(t);
    t.status = !t.status;
    this.updateSelected();
  }

  public updateSelected() {
    this.selectedTypes = [];
    this.releaseNotesTypes.forEach((t) => {
      if (t.status) {
        this.selectedTypes.push(t.type);
      }
    });
    this.setSelectedTypes.emit(this.selectedTypes);
  }

}
